import React, { useEffect, useRef, useState } from "react";
import { Main } from "./styled";

export default function Warn() {
  return (
    <Main>
      <div>Uwaga! Fundacja znajduje się obecnie w procesie likwidacji</div>
    </Main>
  );
}
